import { LocationV1 } from '@csp/dmdp-api-org-dto';
import { createMockCreator } from '@csp/test-common-utils';

const locationV1Mock: LocationV1 = {
  locationId: 'location id',
};

export const createLocationV1Mock = createMockCreator(locationV1Mock);
